import * as React from 'react';

import ExternalRaterNameOrUrl from './ExternalRaterNameOrUrl';
import ExternalRaterHeaders from './ExternalRaterHeaders';

interface Props {
	requestIndex: number;
	externalServiceIntegrationRequest: ExternalServiceIntegrationRequest;
	onChange(
		requestIndex: number,
		externalServiceIntegrationRequest: ExternalServiceIntegrationRequest,
	): void;
	onDelete(requestIndex: number): void;
}

interface State {
	name: string;
	url: string;
	headers: FrontendExternalServiceIntegrationHeader[];
}

function convertFrontendExternalRaterHeadersToRequest(
	headers: FrontendExternalServiceIntegrationHeader[],
): ExternalServiceIntegrationHeaders {
	return headers.reduce((accum, {name, value}) => {
		return {...accum, [name.trim()]: value};
	}, {});
}

export function convertRequestToFrontendExternalRaterHeaders(
	headers: ExternalServiceIntegrationHeaders,
): FrontendExternalServiceIntegrationHeader[] {
	return Object.keys(headers).map(headerName => {
		return {name: headerName, value: headers[headerName]};
	});
}

function getInitialState({externalServiceIntegrationRequest}: Props): State {
	const {name, url, headers} = externalServiceIntegrationRequest;
	return {
		name,
		url,
		headers: convertRequestToFrontendExternalRaterHeaders(headers),
	};
}

export default class AddExternalServiceIntegrations extends React.Component<Props, State> {

	public state: State = getInitialState(this.props);

	constructor(props: Props, context: any) {
		super(props);
		this.handleChangeExternalRaterNameOrUrl = this.handleChangeExternalRaterNameOrUrl.bind(this);
		this.handleChangeExternalRaterHeaders = this.handleChangeExternalRaterHeaders.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.propagateChanges = this.propagateChanges.bind(this);
	}

	public componentDidUpdate(prevProps: Props) {
		if (this.props !== prevProps) {
			this.setState({
				...this.state,
				...getInitialState(this.props),
			});
		}
	}

	public render() {
		return <div className='add-external-service-integration'>
			{this.renderTitle()}
			{this.renderNameAndUrlFields()}
			{this.renderHeaders()}
		</div>;
	}

	private renderTitle() {
		return <div className='row add-external-service-integration-title'>
			<div className='columns'>
				<h4 className='bolder add-external-service-integration-title-text'>
					External Rater #{this.props.requestIndex + 1}
				</h4>
				<i
					className='fa fa-trash is-red delete-icon'
					onClick={this.handleDelete}
				/>
			</div>
		</div>;
	}

	private renderNameAndUrlFields() {
		return <div className='row'>
			<ExternalRaterNameOrUrl
				name='name'
				value={this.state.name}
				onChange={this.handleChangeExternalRaterNameOrUrl}
			/>
			<ExternalRaterNameOrUrl
				name='url'
				value={this.state.url}
				onChange={this.handleChangeExternalRaterNameOrUrl}
			/>
		</div>;
	}

	private renderHeaders() {
		return <ExternalRaterHeaders
			headers={this.state.headers}
			onChange={this.handleChangeExternalRaterHeaders}
		/>;
	}

	private handleChangeExternalRaterNameOrUrl(event: React.FormEvent<HTMLTextAreaElement>) {
		const currentTarget = event.currentTarget as HTMLTextAreaElement;
		const externalRaterAttribute = currentTarget.getAttribute('data-external-rater-attribute');
		const inputValue = currentTarget.value;
		this.setState({
			...this.state,
			[externalRaterAttribute]: inputValue,
		}, this.propagateChanges);
	}

	private handleChangeExternalRaterHeaders(headers: FrontendExternalServiceIntegrationHeader[]) {
		this.setState({
			...this.state,
			headers,
		}, this.propagateChanges);
	}

	private handleDelete() {
		this.props.onDelete(this.props.requestIndex);
	}

	private propagateChanges() {
		this.props.onChange(this.props.requestIndex, {
			...this.state,
			headers: convertFrontendExternalRaterHeadersToRequest(this.state.headers),
		});
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/external-service-integrations/modifiable/AddExternalServiceIntegration.tsx